import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { SinglePaymentActionsComponent } from './single-payment-actions.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ArchiveService } from '../../../../../services/archive.service';
import { PaymentGroupsService } from '../../../../../services/payment/payment-groups.service';
import { GenericMatDialogModule } from '../../../shared/generic-mat-dialog/generic-mat-dialog.module';
import { DeleteOfflinePaymentDialogModule } from 'app/components/app-layout/shared/delete-offline-payment-dialog/delete-offline-payment-dialog.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { EditPaymentDialogModule } from 'app/components/app-layout/payments/incoming-payments/edit-payment-dialog/edit-payment-dialog.module';


@NgModule({
    declarations: [SinglePaymentActionsComponent],
    imports: [
        SharedModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        GenericMatDialogModule,
        MatDialogModule,
        DeleteOfflinePaymentDialogModule,
        EditPaymentDialogModule,
    ],
    exports: [SinglePaymentActionsComponent],
    providers: [
        ArchiveService,
        PaymentGroupsService,
    ],
})
export class SinglePaymentActionsModule
{
}
